import {useState} from "react";
import ReactApexChart from "react-apexcharts";
import {Dropdown} from "react-bootstrap";
import DropdownMenu from "react-bootstrap/esm/DropdownMenu";
import DropdownToggle from "react-bootstrap/esm/DropdownToggle";
import {Line} from "react-chartjs-2";

const RevenueCard = ({
  stats,
  dateLabel,
  setDateLabel,

  optionsList,
}) => {
  const Weekoptions = ["Ce mois", "Cette année"];
  const [option, setOption] = useState("Cette année");
  function getDayNumbersFromStartOfMonthToToday() {
    const today = new Date();
    const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);

    const days = [];
    let currentDate = new Date(startOfMonth);

    while (currentDate <= today) {
      days.push(currentDate.getDate());
      currentDate.setDate(currentDate.getDate() + 1);
    }

    return days;
  }
  const data = {
    labels:
      dateLabel === "Cette Année"
        ? [
            "Janvier",
            "Février",
            "Mars",
            "Avril",
            "Mai",
            "Juin",
            "Juillet",
            "Août",
            "Septembre",
            "Octobre",
            "Novembre",
            "Décembre",
          ]
        : [...getDayNumbersFromStartOfMonthToToday()],
    datasets: [
      {
        label: "My First dataset",
        data: [...Object.values(stats)],

        borderColor: "#FF6600",
        borderWidth: "4",
        backgroundColor: "rgba(67, 121, 238, 0.16)",

        tension: 0.4,
        fill: true,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    elements: {
      point: {
        radius: 0,
      },
    },
    plugins: {
      legend: false,
    },

    scales: {
      y: {
        gridLines: {
          color: "rgba(89, 59, 219,0.1)",
          drawBorder: true,
        },
        ticks: {
          color: "#999",
        },
      },

      x: {
        gridLines: {
          display: false,
          zeroLineColor: "transparent",
        },
        stepSize: 5,
        ticks: {
          color: "#999",
          family: "Nunito, sans-serif",
        },
        grid: {
          display: false,
        },
      },
    },
    tooltips: {
      enabled: true,
      mode: "index",
      intersect: false,
      titleFontColor: "#888",
      bodyFontColor: "#555",
      titleFontSize: 12,
      bodyFontSize: 15,
      backgroundColor: "rgba(256,256,256,0.95)",
      displayColors: true,
      xPadding: 10,
      yPadding: 7,
      borderColor: "rgba(220, 220, 220, 0.9)",
      borderWidth: 2,
      caretSize: 6,
      caretPadding: 10,
    },
  };

  return (
    <div className="w-full !rounded-xl p-6 bg-white flex flex-col gap-3 justify-start items-start">
      <div className="w-full justify-between flex items-center">
        <span className="text-[#19295C] text-lg font-bold">Revenue</span>
        <Dropdown>
          <DropdownToggle
            variant=""
            className=" flex gap-2 items-center !p-0 font-medium !text-xs "
          >
            <span className="mr-2">{dateLabel}</span>
          </DropdownToggle>
          <DropdownMenu>
            {optionsList?.slice(4).map((op, index) => (
              <Dropdown.Item
                key={index}
                onClick={() => {
                  setDateLabel(op.label);
                  op.onClick("Revenue");
                }}
                className="!text-sm"
              >
                {op.label}
              </Dropdown.Item>
            ))}
          </DropdownMenu>
        </Dropdown>
      </div>

      <div className="w-full" style={{height: "300px"}}>
        <Line data={data} options={options} height={300} />
      </div>
    </div>
  );
};

export default RevenueCard;
